import Experience from '../Experience.js';
import Resources from '../Utils/Resources.js';
import Environment from './Environment.js';
import Tamagochi from './Tamagochi.js';
import Background from './Background.js';

export default class World {
    constructor() {
        this.experience = Experience.getInstance();
        this.scene = this.experience.scene;
        this.resources = Resources.getInstance();


        // Wait for resources
        this.resources.on('ready', () => {
            // Setup
            this.enviornment = new Environment();
            this.background = new Background();
            this.tamagochi = new Tamagochi();
        })
    }

    update() {
        if (this.tamagochi)
            this.tamagochi.update();

        if (this.ui)
            this.ui.update();
    }

    resize() {
        if (this.tamagochi)
            this.tamagochi.resize();
    }
}